/**
 * Filtros de Projetos - Barra de busca e filtros
 */
import React from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Search, Filter, Plus, X } from 'lucide-react';
import { STATUS_CONFIG } from './constantes';
import { ViewToggle } from '../ui/view-toggle';

const FiltrosProjetos = ({ 
  searchTerm, 
  setSearchTerm, 
  filterClient, 
  setFilterClient,
  filterStatus,
  setFilterStatus,
  filterModels,
  toggleModelFilter,
  clearFilters,
  uniqueClients,
  usedModels,
  showFilters,
  setShowFilters,
  onNovoClick,
  totalProjetos,
  projetosFiltrados,
  viewMode,
  setViewMode
}) => {
  const hasActiveFilters = filterClient !== 'todos' || filterStatus !== 'todos' || filterModels.length > 0;

  return (
    <div className="space-y-3">
      {/* Linha principal de filtros */}
      <div className="flex flex-wrap gap-3">
        {/* Busca */}
        <div className="relative flex-1 min-w-[200px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
          <Input
            placeholder="Buscar projeto ou cliente..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10"
          />
        </div>

        {/* Filtro por Cliente */}
        <Select value={filterClient} onValueChange={setFilterClient}>
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="Cliente" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="todos">Todos Clientes</SelectItem>
            {uniqueClients.map(client => (
              <SelectItem key={client} value={client}>{client}</SelectItem>
            ))}
          </SelectContent>
        </Select>

        {/* Filtro por Status */}
        <Select value={filterStatus} onValueChange={setFilterStatus}>
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="Status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="todos">Todos Status</SelectItem>
            {Object.entries(STATUS_CONFIG).map(([key, config]) => (
              <SelectItem key={key} value={key}>{config.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>

        {/* Toggle filtros avançados */}
        <Button 
          variant={showFilters ? "default" : "outline"} 
          onClick={() => setShowFilters(!showFilters)}
          className="gap-2"
        >
          <Filter className="h-4 w-4" />
          Modelos
          {filterModels.length > 0 && (
            <Badge variant="secondary" className="ml-1">{filterModels.length}</Badge>
          )}
        </Button>

        {/* Limpar filtros */}
        {hasActiveFilters && (
          <Button variant="ghost" onClick={clearFilters} className="gap-2 text-gray-500">
            <X className="h-4 w-4" />
            Limpar
          </Button>
        )}

        {/* View Toggle */}
        <ViewToggle viewMode={viewMode} setViewMode={setViewMode} />

        {/* Novo Projeto */}
        <Button onClick={onNovoClick} className="gap-2">
          <Plus className="h-4 w-4" />
          Novo Projeto
        </Button>
      </div>

      {/* Filtros de Modelos */}
      {showFilters && usedModels.length > 0 && (
        <div className="flex flex-wrap gap-2 p-3 bg-gray-50 rounded-lg">
          <span className="text-sm text-gray-500 mr-2">Modelos:</span>
          {usedModels.map(model => (
            <Badge
              key={model}
              variant={filterModels.includes(model) ? "default" : "outline"}
              className="cursor-pointer"
              onClick={() => toggleModelFilter(model)}
            >
              {model}
            </Badge>
          ))}
        </div>
      )}

      {/* Info de resultados */}
      {(searchTerm || hasActiveFilters) && (
        <p className="text-sm text-gray-500">
          Mostrando {projetosFiltrados} de {totalProjetos} projetos
        </p>
      )}
    </div>
  );
};

export default FiltrosProjetos;
